module.exports = __webpack_public_path__ + "static/media/qr-help-left.d9b713a7.svg";